const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://200.235.131.157:5000";

export function apiUrl(path) {
  return `${API_BASE_URL}${path}`;
}

export async function parseApiError(response, fallbackMessage) {
  try {
    const data = await response.json();
    return data.error || fallbackMessage;
  } catch (error) {
    return fallbackMessage;
  }
}
